<template>
  <div>
    <div class="text-right mb-5">
      <b-button @click.prevent="openAnnounceDateModal()" variant="primary">{{
        $t("PAGE.DEFAULT.FORM.BTN_ADD")
      }}</b-button>
    </div>

    <!-- Announce date -->
    <div class="table-content">
      <div class="table-responsive">
        <b-table
          id="organizations-table"
          :striped="false"
          :items="items"
          :fields="fields"
          :busy.sync="isBusy"
          :loading="false"
          :borderless="false"
          head-variant="light"
        >
          <template #cell(announce_date)="data">
            <span>{{ formatAnnounceDate(data.item.announce_date) }}</span>
          </template>

          <template #cell(action)="data">
            <a
              href="javascript:"
              @click.prevent="
                openAnnounceCustomerModal(data.item.id, data.item.announce_date)
              "
              class="btn btn-icon btn-light btn-sm mr-3"
            >
              <span class="svg-icon svg-icon-md svg-icon-success">
                <inline-svg
                  src=" media/svg/icons/General/User.svg"
                ></inline-svg>
              </span>
            </a>

            <a
              href="javascript:"
              @click.prevent="openAnnounceDateModal(data.item.id)"
              class="btn btn-icon btn-light btn-sm mr-3"
            >
              <span class="svg-icon svg-icon-md svg-icon-success">
                <inline-svg
                  src=" media/svg/icons/General/Edit.svg"
                ></inline-svg>
              </span>
            </a>
            <a
              href="javascript:"
              @click.prevent="deleteAnnounceDate(data.item.id)"
              class="btn btn-icon btn-light btn-sm"
              :aria-label="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.TITLE')"
            >
              <span class="svg-icon svg-icon-md svg-icon-danger">
                <inline-svg
                  src="media/svg/icons/General/Trash.svg"
                ></inline-svg>
              </span>
            </a>
          </template>
        </b-table>

        <p class="text-center pt-3" v-if="items.length < 1">
          {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
        </p>
      </div>
    </div>

    <!-- Modal announce date form -->
    <b-modal
      size="m"
      id="modal-form-announce-date"
      ref="modal-form-announce-date"
      :title="
        this.$t(
          'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.ANNOUNCE_DATE'
        )
      "
      :ok-title="this.$t('PAGE.DEFAULT.FORM.BTN_SUBMIT')"
      :cancel-title="this.$t('PAGE.DEFAULT.FORM.BTN_CANCEL')"
      @ok="handleSubmitFormDate"
    >
      <form
        ref="form_announce_date"
        @submit.stop.prevent="handleSubmitFormDate"
      >
        <b-row class="mb-5 text-center">
          <b-col sm="4">
            <label>
              <h5>
                {{
                  $t(
                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.LABEL_DATE"
                  )
                }}
              </h5>
            </label>
          </b-col>

          <b-col sm="8" class="text-left">
            <date-picker
              id="start-date-datepicker"
              v-model="$v.form_announce_date.value.announce_date.$model"
              :config="datepickerOptions"
              autocomplete="off"
            ></date-picker>
            <span
              v-if="
                form_announce_date.is_submit &&
                !$v.form_announce_date.value.announce_date.required
              "
              class="error text-danger"
            >
              {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
            </span>
          </b-col>
        </b-row>

        <b-row class="mb-5 text-center">
          <b-col sm="4">
            <label>
              <h5>
                {{
                  $t(
                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.LABEL_IMAGE"
                  )
                }}
              </h5>
            </label>
          </b-col>

          <b-col sm="8" class="text-left">
            <b-form-file
              id="input-image"
              name="image"
              type="file"
              v-model="$v.form_announce_date.value.image.$model"
              accept="image/*"
              @change="setImagePreivew($event)"
              placeholder="No logo image chosen"
              class="text-truncate"
            ></b-form-file>
          </b-col>
        </b-row>

        <b-row v-if="form_announce_date.image_preview" class="mb-5 text-center">
          <b-col sm="12" class="text-left">
            <div class="mb-2">
              <img
                class="image-preview"
                width="100%"
                :src="form_announce_date.image_preview"
              />
            </div>

            <div>
              <b-button @click="removeImage" class="btn btn-danger btn-block">
                <i class="fa fa-trash"></i>
                <span class="ml-3">
                  {{
                    $t(
                      "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.BTN_REMOVE_IMAGE"
                    )
                  }}
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </form>
    </b-modal>

    <!-- Modal announce customer form -->
    <b-modal
      size="xl"
      id="modal-form-announce-customer"
      ref="modal-form-announce-customer"
      :title="
        this.$t(
          'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.ANNOUNCE_CUSTOMER'
        )
      "
      :ok-title="this.$t('PAGE.DEFAULT.FORM.BTN_CANCEL')"
      ok-only
    >
      <div>
        <b-card no-body>
          <h3 class="text-right mt-5 mr-5">
            {{
              $t(
                "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.ANNOUNCE_DATE"
              )
            }}
            {{ formatAnnounceDate(announce_date) }}
          </h3>

          <b-tabs card>
            <!-- Tab form customer -->
            <b-tab
              id="tab-customer"
              :title="
                this.$t(
                  'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.CUSTOMER'
                )
              "
            >
              <!-- Customer form -->
              <div class="card card-custom gutter-b">
                <div class="card-body">
                  <div class="form-customer">
                    <b-form
                      ref="form_announce_message"
                      @submit.stop.prevent="handleSubmitFormCustomer"
                    >
                      <h3 class="text-center mb-8">
                        {{
                          $t(
                            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.CUSTOMER_FORM_TITLE"
                          )
                        }}
                      </h3>

                      <b-row class="mb-5">
                        <b-col sm="3">
                          <label>
                            <h5>
                              {{
                                $t(
                                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.RECEIPT_CODE"
                                )
                              }}
                            </h5>
                          </label>
                        </b-col>

                        <b-col sm="9">
                          <b-form-input
                            id="receipt_code-input"
                            name="receipt_code-input"
                            v-model="
                              $v.form_announce_customer.value.receipt_code
                                .$model
                            "
                            @keyup="verfiyReceiptCode()"
                          ></b-form-input>

                          <span
                            v-if="
                              form_announce_customer.is_submit &&
                              !$v.form_announce_customer.value.receipt_code
                                .required
                            "
                            class="error text-danger"
                          >
                            {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                          </span>

                          <span
                            v-if="
                              form_announce_customer.is_submit &&
                              this.form_announce_customer.invalid_receipt_code
                            "
                            class="error text-danger"
                          >
                            {{
                              $t(
                                "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.INVALID_RECEIPT_CODE"
                              )
                            }}
                          </span>
                        </b-col>
                      </b-row>

                      <b-row class="mb-5">
                        <b-col sm="3">
                          <label>
                            <h5>
                              {{
                                $t(
                                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.CUSTOMER_NAME"
                                )
                              }}
                            </h5>
                          </label>
                        </b-col>

                        <b-col sm="9">
                          <b-form-input
                            id="customer_name-input"
                            name="customer_name-input"
                            v-model="form_announce_customer.customer_name"
                            disabled
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <b-row class="mb-5">
                        <b-col sm="3">
                          <label>
                            <h5>
                              {{
                                $t(
                                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.PHONE_NUMBER"
                                )
                              }}
                            </h5>
                          </label>
                        </b-col>

                        <b-col sm="9">
                          <b-form-input
                            id="phone_number-input"
                            name="phone_number-input"
                            v-model="form_announce_customer.phone_number"
                            disabled
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <b-row class="mb-5">
                        <b-col sm="3">
                          <label>
                            <h5>
                              {{
                                $t(
                                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.CAMPAIGN_REWARD_NAME"
                                )
                              }}
                            </h5>
                          </label>
                        </b-col>

                        <b-col sm="9">
                          <b-form-input
                            id="campaign_reward_name-input"
                            name="campaign_reward_name-input"
                            v-model="
                              form_announce_customer.campaign_reward_name
                            "
                            disabled
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <b-row class="mb-5">
                        <b-col sm="3">
                          <label>
                            <h5>
                              <span>
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.REWARD"
                                  )
                                }}
                              </span>

                              <b-button
                                id="popover-button-sync"
                                class="float-right btn btn-default btn-circle ml-3"
                              >
                                <i class="fa fa-info"></i>
                              </b-button>
                              <b-popover target="popover-button-sync">
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.INPUT_REWARD_INFO"
                                  )
                                }}
                              </b-popover>
                            </h5>
                          </label>
                        </b-col>

                        <b-col sm="9">
                          <b-form-input
                            id="reward_name-input"
                            name="reward_name-input"
                            v-model="form_announce_customer.value.reward_name"
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="12" class="text-center">
                          <b-button type="submit" variant="primary">{{
                            $t(
                              "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.BUTTON_ADD"
                            )
                          }}</b-button>
                        </b-col>
                      </b-row>
                    </b-form>
                  </div>
                </div>
              </div>

              <!-- Customer list -->
              <div class="card card-custom gutter-b">
                <div class="card-body">
                  <div class="table-customer">
                    <div class="table-responsive">
                      <b-table
                        id="organizations-table"
                        :striped="false"
                        :items="customer_items"
                        :fields="customer_fields"
                        :busy.sync="isBusy"
                        :loading="false"
                        :borderless="false"
                        head-variant="light"
                      >
                        <template #cell(customer_name)="data">
                          <span>{{
                            `${data.item.first_name} ${data.item.last_name}`
                          }}</span>
                        </template>

                        <template #cell(reward)="data">
                          <span>{{ data.item.campaign_reward_name }}</span>

                          <span v-if="data.item.reward_name">
                            ({{ data.item.reward_name }})</span
                          >
                        </template>

                        <template #cell(action)="data">
                          <a
                            href="javascript:"
                            @click.prevent="
                              deleteAnnounceCustomer(data.item.id)
                            "
                            class="btn btn-icon btn-light btn-sm"
                            :aria-label="
                              $t(
                                'PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.TITLE'
                              )
                            "
                          >
                            <span class="svg-icon svg-icon-md svg-icon-danger">
                              <inline-svg
                                src="media/svg/icons/General/Trash.svg"
                              ></inline-svg>
                            </span>
                          </a>
                        </template>
                      </b-table>

                      <p
                        class="text-center pt-3"
                        v-if="customer_items.length < 1"
                      >
                        {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>

            <!-- Tab form message -->
            <b-tab
              id="tab-message"
              :title="
                this.$t(
                  'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.SEND_MESSAGE'
                )
              "
            >
              <!-- Message form -->
              <div class="card card-custom gutter-b">
                <div class="card-body">
                  <div class="form-msg">
                    <b-form
                      ref="form_announce_message"
                      @submit.stop.prevent="handleSubmitFormMessage"
                    >
                      <h3 class="text-center mb-8">
                        {{
                          $t(
                            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.SEND_MESSAGE"
                          )
                        }}
                      </h3>

                      <div class="row">
                        <div class="col-lg-3">
                          <label>
                            <h5>
                              {{
                                $t(
                                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.LABEL_EX_MESSAGE"
                                )
                              }}
                            </h5>
                          </label>
                        </div>

                        <div class="col-lg-9">
                          <div class="ex-message">
                            <p>
                              <span
                                v-html="
                                  $t(
                                    'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.EX_MESSAGE'
                                  )
                                "
                              ></span>
                              {{ this.form_announce_message.value.message }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-3">
                          <label>
                            <h5>
                              <span>
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.MESSAGE"
                                  )
                                }}
                              </span>

                              <b-button
                                id="popover-button2-sync"
                                class="float-right btn btn-default btn-circle ml-3"
                              >
                                <i class="fa fa-info"></i>
                              </b-button>
                              <b-popover target="popover-button2-sync">
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.INPUT_MESSAGE_INFO"
                                  )
                                }}
                              </b-popover>
                            </h5>
                          </label>
                        </div>

                        <div class="col-lg-9">
                          <b-form-textarea
                            id="message-input"
                            name="message-input"
                            rows="4"
                            max-rows="6"
                            v-model="form_announce_message.value.message"
                          ></b-form-textarea>

                          <span
                            v-if="
                              form_announce_message.is_submit &&
                              !$v.form_announce_message.value.message.required
                            "
                            class="error text-danger"
                          >
                            {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                          </span>
                        </div>
                      </div>

                      <div class="row mt-5">
                        <div class="col-lg-12 text-center">
                          <b-button type="submit" variant="primary">{{
                            $t(
                              "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.SEND_MESSAGE"
                            )
                          }}</b-button>
                        </div>
                      </div>
                    </b-form>
                  </div>
                </div>
              </div>

              <!-- Message list -->
              <div class="card card-custom gutter-b">
                <div class="card-body">
                  <div class="table-msg">
                    <div class="table-responsive">
                      <b-table
                        id="organizations-table"
                        :striped="false"
                        :items="message_items"
                        :fields="message_fields"
                        :busy.sync="isBusy"
                        :loading="false"
                        :borderless="false"
                        head-variant="light"
                      >
                      </b-table>

                      <p
                        class="text-center pt-3"
                        v-if="message_items.length < 1"
                      >
                        {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import datePicker from "vue-bootstrap-datetimepicker";
import Swal from "sweetalert2";
import {
  GET_CAMPAIGN_ANNOUNCE_REWARD,
  FIND_CAMPAIGN_ANNOUNCE_REWARD,
  CREATE_CAMPAIGN_ANNOUNCE_REWARD,
  UPDATE_CAMPAIGN_ANNOUNCE_REWARD,
  DELETE_CAMPAIGN_ANNOUNCE_REWARD
} from "@/core/services/store/campaign_announce_reward.module";
import {
  GET_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER,
  VERIFY_CAMPAIGN_RECEIPT_CODE,
  CREATE_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER,
  DELETE_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER
} from "@/core/services/store/campaign_announce_reward_customer.module";
import {
  GET_CAMPAIGN_ANNOUNCE_REWARD_MESSAGE,
  CREATE_CAMPAIGN_ANNOUNCE_REWARD_MESSAGE
} from "@/core/services/store/campaign_announce_reward_message.module";

export default {
  name: "CampaignAnnouncement",
  mixins: [validationMixin],
  props: ["campaign_id"],
  components: {
    datePicker
  },
  data() {
    return {
      // Announce date
      fields: [
        {
          key: "announce_date",
          label: `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.ANNOUNCE_DATE"
          )}`,
          key_table: "announce_date",
          sortable: false,
          isFilter: false
        },
        {
          key: "action",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE")}`,
          sortable: false,
          isFilter: false,
          thClass: "text-right",
          tdClass: "text-right"
        }
      ],
      isBusy: false,
      items: [],
      total: 0,
      datepickerOptions: {
        useCurrent: false,
        locale: "th",
        icons: {
          time: "fas fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        },
        format: "YYYY-MM-DD"
      },
      form_announce_date: {
        id: null,
        value: {
          campaign_id: this.campaign_id,
          announce_date: null,
          image: null,
          current_image: null,
          is_delete_image: false
        },
        is_submit: false,
        image_preview: null
      },

      // Announce customer
      announce_date: null,
      customer_fields: [
        {
          key: "customer_name",
          label: `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.CUSTOMER_NAME"
          )}`,
          key_table: "customer_name",
          sortable: false,
          isFilter: false
        },
        {
          key: "phone_number",
          label: `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.PHONE_NUMBER"
          )}`,
          key_table: "phone_number",
          sortable: false,
          isFilter: false
        },
        {
          key: "receipt_code",
          label: `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.RECEIPT_CODE"
          )}`,
          key_table: "receipt_code",
          sortable: false,
          isFilter: false
        },
        {
          key: "reward",
          label: `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.REWARD"
          )}`,
          key_table: "reward",
          sortable: false,
          isFilter: false
        },
        {
          key: "action",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE")}`,
          sortable: false,
          isFilter: false,
          thClass: "text-right",
          tdClass: "text-right"
        }
      ],
      customer_items: [],
      customer_total: 0,
      form_announce_customer: {
        value: {
          campaign_id: this.campaign_id,
          campaign_announce_reward_id: null,
          customer_campaign_receipt_id: null,
          customer_id: null,
          receipt_code: null,
          reward_name: null
        },
        customer_name: null,
        phone_number: null,
        campaign_reward_name: null,
        is_submit: false,
        invalid_receipt_code: false
      },

      // Announce message
      message_fields: [
        {
          key: "created_at",
          label: `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.MESSAGE_DATE"
          )}`,
          key_table: "created_at",
          sortable: false,
          isFilter: false
        },
        {
          key: "message",
          label: `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.MESSAGE"
          )}`,
          key_table: "message",
          sortable: false,
          isFilter: false
        }
      ],
      message_items: [],
      message_total: 0,
      form_announce_message: {
        value: {
          campaign_id: this.campaign_id,
          campaign_announce_reward_id: null,
          message: null
        },
        is_submit: false
      }
    };
  },
  validations: {
    form_announce_date: {
      value: {
        announce_date: {
          required
        },
        image: {}
      }
    },
    form_announce_customer: {
      value: {
        receipt_code: {
          required
        }
      }
    },
    form_announce_message: {
      value: {
        message: {
          required
        }
      }
    }
  },
  mounted() {
    this.getDataAnnounceDate();
  },
  methods: {
    getDataAnnounceDate() {
      this.$store
        .dispatch(GET_CAMPAIGN_ANNOUNCE_REWARD, {
          params: {
            campaign_id: this.campaign_id
          }
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.items = data.data.data;
            this.total = data.data.total;
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    findAnnounceDate(id) {
      this.$store
        .dispatch(FIND_CAMPAIGN_ANNOUNCE_REWARD, { id })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.form_announce_date.id = data.data.id;
            this.form_announce_date.value.announce_date = new Date(
              data.data.announce_date
            );
            this.form_announce_date.value.current_image = data.data.image;

            if (data.data.image) {
              this.form_announce_date.image_preview = `${process.env.VUE_APP_IMAGE}${data.data.image}`;
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    deleteAnnounceDate(id) {
      Swal.fire({
        text: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.DESC")}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(DELETE_CAMPAIGN_ANNOUNCE_REWARD, { id })
            .then(({ data }) => {
              Swal.close();

              if (data.status === "success") {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                this.getDataAnnounceDate();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
              this.isBusy = false;
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                text: `${error.error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
              this.isBusy = false;
            });
        }
      });
    },
    formatAnnounceDate(date) {
      date = new Date(date);
      date.setHours(date.getHours() + 7);
      return date.toISOString().split("T")[0];
    },

    // Modal announce date
    openAnnounceDateModal(id = null) {
      this.clearFormDate();

      if (id) {
        this.findAnnounceDate(id);
      }

      this.$bvModal.show("modal-form-announce-date");
    },
    setImagePreivew(event) {
      try {
        this.form_announce_date.image_preview = URL.createObjectURL(
          event.target.files[0]
        );
      } catch {
        this.form_announce_date.image_preview = null;
      }
    },
    removeImage() {
      this.form_announce_date.value.image = null;
      this.form_announce_date.image_preview = null;
      this.form_announce_date.value.is_delete_image = true;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form_announce_date.value[name];
      return $dirty ? !$error : null;
    },
    clearFormDate() {
      this.form_announce_date.id = null;
      this.form_announce_date.value = {
        campaign_id: this.campaign_id,
        announce_date: null,
        image: null,
        current_image: null,
        is_delete_image: false
      };
      this.form_announce_date.image_preview = null;
      this.form_announce_date.is_submit = false;
    },
    handleSubmitFormDate(bvModalEvt) {
      this.form_announce_date.is_submit = true;
      bvModalEvt.preventDefault();
      this.$v.form_announce_date.$touch();

      if (this.$v.form_announce_date.value.$anyError) {
        return;
      }

      let formData = new FormData();

      formData.append("campaign_id", this.form_announce_date.value.campaign_id);
      formData.append(
        "announce_date",
        this.form_announce_date.value.announce_date
      );
      formData.append(
        "is_delete_image",
        this.form_announce_date.value.is_delete_image
      );

      if (this.form_announce_date.value.image) {
        formData.append("image", this.form_announce_date.value.image);
      }

      if (!this.form_announce_date.id) {
        this.handleSaveFormDate(formData);
      } else {
        this.handleUpdateFormDate(this.form_announce_date.id, formData);
      }
    },
    handleSaveFormDate(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(CREATE_CAMPAIGN_ANNOUNCE_REWARD, { data })
            .then(({ data }) => {
              Swal.close();

              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  html: `${this.$t("RESPONSE_MESSAGE.SAVE_DATA_SUCCESS")}`
                });
                this.$v.$reset();
                this.$nextTick(() => {
                  this.$bvModal.hide("modal-form-announce-date");
                });
                this.getDataAnnounceDate();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: this.$t("RESPONSE_MESSAGE." + data.error),
                  confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
                });
              }
            })
            .catch((error) => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: error,
                confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
              });
            });
        }
      });
    },
    handleUpdateFormDate(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(UPDATE_CAMPAIGN_ANNOUNCE_REWARD, { id, data })
            .then(({ data }) => {
              Swal.close();

              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  html: `${this.$t("RESPONSE_MESSAGE.SAVE_DATA_SUCCESS")}`
                });
                this.$v.$reset();
                this.$nextTick(() => {
                  this.$bvModal.hide("modal-form-announce-date");
                });
                this.getDataAnnounceDate();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: this.$t("RESPONSE_MESSAGE." + data.error),
                  confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
                });
              }
            })
            .catch((error) => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: error,
                confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
              });
            });
        }
      });
    },
    deleteAnnounceCustomer(id) {
      Swal.fire({
        text: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.DESC")}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(DELETE_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER, { id })
            .then(({ data }) => {
              Swal.close();

              if (data.status === "success") {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                this.getDataAnnounceCustomer();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
              this.isBusy = false;
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                text: `${error.error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
              this.isBusy = false;
            });
        }
      });
    },

    // Modal announce customer and message
    openAnnounceCustomerModal(id, date) {
      this.clearFormCustomer();
      this.clearFormMessage();
      this.announce_date = date;
      this.form_announce_customer.value.campaign_announce_reward_id = id;
      this.form_announce_message.value.campaign_announce_reward_id = id;
      this.getDataAnnounceCustomer();
      this.getDataAnnounceMessage();
      this.$bvModal.show("modal-form-announce-customer");
    },

    // Form announce customer
    getDataAnnounceCustomer() {
      this.$store
        .dispatch(GET_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER, {
          params: {
            campaign_announce_reward_id:
              this.form_announce_customer.value.campaign_announce_reward_id
          }
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.customer_items = data.data.data;
            this.customer_total = data.data.total;
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    clearFormCustomer() {
      this.form_announce_customer.value.receipt_code = null;
      this.form_announce_customer.value.reward_name = null;
      this.form_announce_customer.customer_name = null;
      this.form_announce_customer.phone_number = null;
      this.form_announce_customer.campaign_reward_name = null;
      this.form_announce_customer.is_submit = false;
      this.form_announce_customer.invalid_receipt_code = false;
    },
    clearFormCustomerVerified(invalidReceiptCode) {
      this.form_announce_customer.value.customer_campaign_receipt_id = null;
      this.form_announce_customer.value.customer_id = null;
      this.form_announce_customer.customer_name = null;
      this.form_announce_customer.phone_number = null;
      this.form_announce_customer.campaign_reward_name = null;

      this.$nextTick(() => {
        this.form_announce_customer.invalid_receipt_code = invalidReceiptCode;
      });
    },
    verfiyReceiptCode: _.debounce(async function () {
      if (this.form_announce_customer.value.receipt_code) {
        let params = {
          campaign_id: this.campaign_id,
          receipt_code: this.form_announce_customer.value.receipt_code
        };

        this.$store
          .dispatch(VERIFY_CAMPAIGN_RECEIPT_CODE, { params: params })
          .then(({ data }) => {
            if (data.data) {
              this.form_announce_customer.value.customer_id =
                data.data.customer_id;
              this.form_announce_customer.value.customer_campaign_receipt_id =
                data.data.customer_campaign_receipt_id;
              this.form_announce_customer.customer_name = `${data.data.first_name} ${data.data.last_name}`;
              this.form_announce_customer.phone_number = data.data.phone_number;
              this.form_announce_customer.campaign_reward_name =
                data.data.campaign_reward_name;

              this.$nextTick(() => {
                this.form_announce_customer.invalid_receipt_code = false;
              });
            } else {
              this.clearFormCustomerVerified(true);
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              text: `${error.error}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          });
      } else {
        this.clearFormCustomerVerified(false);
      }
    }, 300),
    handleSubmitFormCustomer(bvModalEvt) {
      this.form_announce_customer.is_submit = true;
      bvModalEvt.preventDefault();
      this.$v.form_announce_customer.$touch();

      if (this.$v.form_announce_customer.value.$anyError) {
        return;
      } else if (
        !this.form_announce_customer.value.customer_campaign_receipt_id
      ) {
        this.$nextTick(() => {
          this.form_announce_customer.invalid_receipt_code = true;
        });
        return;
      } else {
        this.$nextTick(() => {
          this.form_announce_customer.invalid_receipt_code = false;
        });
      }

      this.handleSaveFormCustomer(this.form_announce_customer.value);
    },
    handleSaveFormCustomer(data) {
      Swal.fire({
        text: `${this.$t(
          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.CONFIRM_ADD_CUSTOMER"
        )}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(CREATE_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER, { data })
            .then(({ data }) => {
              Swal.close();

              if (data.status === "success") {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                this.clearFormCustomer();
                this.getDataAnnounceCustomer();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
              this.isBusy = false;
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                text: `${error.error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
              this.isBusy = false;
            });
        }
      });
    },

    // Form announce message
    getDataAnnounceMessage() {
      this.$store
        .dispatch(GET_CAMPAIGN_ANNOUNCE_REWARD_MESSAGE, {
          params: {
            campaign_announce_reward_id:
              this.form_announce_customer.value.campaign_announce_reward_id
          }
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.message_items = data.data.data;
            this.message_total = data.data.total;
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    clearFormMessage() {
      this.form_announce_message.value.message = null;
      this.form_announce_message.is_submit = false;
    },
    handleSubmitFormMessage(bvModalEvt) {
      this.form_announce_message.is_submit = true;
      bvModalEvt.preventDefault();
      this.$v.form_announce_message.$touch();

      if (this.$v.form_announce_message.value.$anyError) {
        return;
      }

      this.handleSaveFormMessage(this.form_announce_message.value);
    },
    handleSaveFormMessage(data) {
      Swal.fire({
        text: `${this.$t(
          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_ANNOUNCE_REWARD.CONFIRM_SEND_MESSAGE"
        )}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(CREATE_CAMPAIGN_ANNOUNCE_REWARD_MESSAGE, { data })
            .then(({ data }) => {
              Swal.close();

              if (data.status === "success") {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                this.message_total += 1;
                this.clearFormMessage();
                this.getDataAnnounceMessage();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
              this.isBusy = false;
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                text: `${error.error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
              this.isBusy = false;
            });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.form-customer,
.form-msg {
  width: 65%;
  margin: auto;
}
</style>
